module.exports = __webpack_public_path__ + "img/logo.e49dd4f7.png";